import { displayName, lifespan, type Person } from '@lineage/core';
import { useNavigate } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { Portrait } from '../canvas/PersonCard';
import { useView } from '../canvas/store';
import { useLang } from '../../i18n';

/** Opens the tree with this person selected. */
export function useOpenPerson(treeId: string) {
  const nav = useNavigate();
  return (id: string) => {
    useView.getState().select(id);
    void nav({ to: '/t/$treeId', params: { treeId } });
  };
}

export function PersonRow({ person, sub, aside, onOpen, dim }: { person: Person; sub?: ReactNode; aside?: ReactNode; onOpen: (id: string) => void; dim?: boolean }) {
  const lang = useLang();
  return (
    <button type="button" className="list-item" onClick={() => onOpen(person.id)} style={dim ? { opacity: 0.6 } : undefined}>
      <Portrait person={person} small px={64} />
      <div className="grow" style={{ minWidth: 0 }}>
        <strong style={{ fontSize: 18 }}>{displayName(person)}</strong>
        <div className="muted" style={{ fontSize: 15 }}>{sub ?? lifespan(person, lang)}</div>
      </div>
      {aside && <div className="muted" style={{ fontSize: 15, textAlign: 'right', flexShrink: 0 }}>{aside}</div>}
    </button>
  );
}
